import './NavigationDialog.scss';

import WarningIcon from '@mui/icons-material/Warning';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { NavigationGuardDialogProps } from 'types/Dialog.types';

/**
 * Confirmation dialog for navigation guards.
 * Renders when `open` is true; otherwise renders nothing.
 */
const NavigationDialog = ({
  open,
  dialogTitle,
  dialogText,
  additionalText,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
}: NavigationGuardDialogProps) => {
  if (!open) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth='sm'
      fullWidth
      aria-labelledby='navigation-guard-title'
      aria-describedby='navigation-guard-description'
    >
      <DialogTitle id='navigation-guard-title'>
        <WarningIcon className='warning-icon' />
        {dialogTitle}
      </DialogTitle>

      <DialogContent>
        <Typography id='navigation-guard-description' variant='body1'>
          {dialogText}
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          {additionalText}
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel} variant='outlined'>
          {cancelText}
        </Button>
        <Button onClick={onConfirm} variant='contained' autoFocus>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NavigationDialog;
